// extracted by mini-css-extract-plugin
export default {"rc_wrap":"ReportCard_rc_wrap__46Mvi","title":"ReportCard_title__5V1Im","value":"ReportCard_value__MNImk","grade":"ReportCard_grade__Wz1VC"};